export const BACKEND_URL = "https://api.paste.quangdel.com"
// export const BACKEND_URL = "http://localhost:8080"
